export default __webpack_public_path__ + "static/media/archer-card.fac50829.png";